import classes from './SvgComponent.module.css';
import React from 'react';

import AssessmentSVG from './svgs/Assessment.svg';
import AssessmentBorderSVG from './svgs/AssessmentBorder.svg';

const svgsComponents = {
    assessment: AssessmentSVG,
    border: AssessmentBorderSVG
};

const SvgComponent = ({ color, name, size = "32px", onClick, className }) => {

    const IconComponent = svgsComponents[name];

    return <div
        className={`${classes.Icon} ${className} `}
        onClick={onClick && onClick}
        dangerouslySetInnerHTML={{ __html: IconComponent }} style={{ color: color && color, stroke: color && color, width: size, height: size }}>
    </div>
}
export default SvgComponent;

